import React from 'react';
import LongText from '../../../Elements/LongText';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import selectHelper from '../../../Helpers/selectHelper';
import { formatMonthLabel } from '../../../Helpers/invoiceAutomationMonthHelper';
import { getRunChangeDetail } from '../../../Helpers/invoiceAutomationRunHelper';
import InvoiceAutomationRunChangeTypeOptionsArray from '../../../Enums/InvoiceAutomationRunChangeTypeOptionsArray';
import InvoiceAutomationJobId from '../../../Contents/ThirdParty/Project/InvoiceAutomation/InvoiceAutomationJobId.tsx';
import InvoiceAutomationInvoiceId from '../../../Contents/ThirdParty/Project/InvoiceAutomation/InvoiceAutomationInvoiceId.tsx';
import InvoiceAutomationProjectId from '../../../Contents/ThirdParty/Project/InvoiceAutomation/InvoiceAutomationProjectId.tsx';

// One change a run of automatic invoicing made, as the run's details list it.
export default class InvoiceAutomationRunChangeItem {
  constructor(item) {
    if (item === undefined) {
      this.InvoiceAutomationRunChangeId = '';
      this.ChangeType = '';
      this.TpClientInvoiceId = '';
      this.TpJobId = '';
      this.ThirdPartyJobId = '';
      this.ProjectId = null;
      this.ProjectName = null;
      this.JobMonth = '';
      this.Detail = '';
      this.CurrencyCode = '';
      this.TpJobPricingCurrencyCode = '';
      this.CreatedOnUtc = '';
      return;
    }

    this.InvoiceAutomationRunChangeId = item.invoiceAutomationRunChangeId;
    this.ChangeType = item.changeType;
    this.TpClientInvoiceId = item.tpClientInvoiceId ?? '';
    this.TpJobId = item.tpJobId ?? '';
    this.ThirdPartyJobId = item.thirdPartyJobId ?? '';
    // The job's project as it is now.
    this.ProjectId = item.projectId ?? null;
    this.ProjectName = item.projectName ?? null;
    this.JobMonth = item.jobMonth;
    this.Detail = item.detail ?? '';
    this.CurrencyCode = item.currencyCode ?? '';
    this.TpJobPricingCurrencyCode = item.tpJobPricingCurrencyCode ?? '';
    this.CreatedOnUtc = item.createdOnUtc;
  }

  static NameOfTheIdField() {
    return 'InvoiceAutomationRunChangeId';
  }

  static nameOfTheItemDetailList() {
    return 'Automatic Invoicing Change';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateOnlyFields = [];

  static DateFields = [];

  static BoolFields = [];

  static getTime(item) {
    return dateTimeHelper.utcToLocalYYYYsMMsDDsHHsMM(item.CreatedOnUtc);
  }

  static getChange(item) {
    return selectHelper.getOptionLabel(InvoiceAutomationRunChangeTypeOptionsArray, item.ChangeType);
  }

  static getMonth(item) {
    return formatMonthLabel(item.JobMonth);
  }

  static getDetail(item) {
    return (
      <LongText
        text={getRunChangeDetail(item.ChangeType, item.Detail, item.CurrencyCode, item.TpJobPricingCurrencyCode)}
        maxLength={80}
      />
    );
  }

  static getInvoice(item) {
    return <InvoiceAutomationInvoiceId tpClientInvoiceId={item.TpClientInvoiceId} />;
  }

  static getJob(item) {
    return (
      <InvoiceAutomationJobId
        tpJobId={item.TpJobId}
        thirdPartyJobId={item.ThirdPartyJobId}
      />
    );
  }

  static getProject(item) {
    return (
      <InvoiceAutomationProjectId
        projectId={item.ProjectId}
        projectName={item.ProjectName}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Time', orderById: '', data: InvoiceAutomationRunChangeItem.getTime },
      { label: 'Change', orderById: '', data: InvoiceAutomationRunChangeItem.getChange },
      { label: 'Month', orderById: '', data: InvoiceAutomationRunChangeItem.getMonth },
      { label: 'Invoice', orderById: '', data: InvoiceAutomationRunChangeItem.getInvoice },
      { label: 'Job', orderById: '', data: InvoiceAutomationRunChangeItem.getJob },
      { label: 'Project', orderById: '', data: InvoiceAutomationRunChangeItem.getProject },
      { label: 'Detail', orderById: '', data: InvoiceAutomationRunChangeItem.getDetail },
    ];
  }
}
